module.exports = __webpack_public_path__ + "img/banner.61dd51db.png";